import translations from "../../translations/files/en_GB.json";
import { main } from "./main";

main(translations);
